/**
 * Maps a chart's aggregation choice onto the unit the widget API expects.
 * @param {string} aggregation - One of minute, hour, day, week, month.
 * @returns {string} Plural unit understood by buildWidgetConfig.
 */
export const getAggregationUnit = (aggregation) => {
  const map = {
    minute: 'minutes',
    hour: 'hours',
    day: 'days',
    week: 'weeks',
    month: 'months'
  };
  return map[aggregation] || 'hours';
};
